import {Component, Input, OnInit, Output} from '@angular/core';
import {RewardService} from "../../../shared/services/reward.service";
import {RewardsSummaryService} from "../../../shared/services/rewards-summary.service";
import {ParamService} from "../../../shared/services/param.service";
import {AuthService} from "../../../shared/services/auth.service";
import {PointsModalService} from "../../../shared/services/points-modal.service";
declare const $: any;
@Component({
    selector: 'app-more-ways-to-use',
    templateUrl: './more-ways-to-use.component.html',
    styleUrls: ['./more-ways-to-use.component.scss']
})
export class MoreWaysToUseComponent implements OnInit {

    @Input() enableCashReward: boolean;
    @Input() pointScoreCardFlow: boolean;
    @Input() userInfo: any;
    @Input() appHostURL: any;
    @Input() currentEnvironment: any;
    @Input() rewardsResponseObj;
    b4UGalleryData: any;
    moreWaysToUseData: any;
    public showLoading = true;
    public error = false;
    public errorMessage: string;
    public rewardCardDisabled = false;
    @Output() isMoreWaysToUseFlow: boolean = false;
    public autoRewardsPoints: number;
    public balance: number;
    public dollarDiscount: number;
    public willExpire: number;
    public isUserHasRewards: boolean;
    public rewardsPointsValueDetailsDisplay: string;
    public rewardsPointsDateDetailsDisplay: string;


  constructor(public _rewardGridService: RewardService,
              private _rewardSummaryService: RewardsSummaryService,
              private paramService: ParamService,
              private authService: AuthService,
              private pointsModalService: PointsModalService) {
              this.rewardCardDisabled = false;
    }

    ngOnInit(): void {
        this._init();
    }

    private _init() {
        this.moreWaysToUseData = JSON.parse(localStorage.getItem('abRewards')).moreWaysToUseOffers.slice(0, 30) || [];
        this.moreWaysToUseData = this.moreWaysToUseData.filter(reward => !!reward.pointsRequired);
        this.moreWaysToUseData = this.moreWaysToUseData.sort((a, b) => (a.pointsRequired - b.pointsRequired) || (a.specialRank - b.specialRank));
        this.isMoreWaysToUseFlow = true;
        if (this.moreWaysToUseData.length > 0) {
            const rewardsObj = this.rewardsResponseObj;
            this.setScoreCardValueInRewards(rewardsObj);
            this.showLoading = false;
            this.focusOnRewardGrid();
            this.analyticsEvents();
        } else {
            this._showError();
            this.analyticsEvents('No extra rewards available at this time');
        }
    }
 
    triggerMoreWaysToUseApi(){
      this._init();
    }

    setScoreCardValueInRewards(rewardsObj) {
      const rewards = rewardsObj?.rewards;

      this.autoRewardsPoints = 0;
      this.balance = 0;
      this.dollarDiscount = 0;
      this.willExpire = 0;
      this.isUserHasRewards = false;

      if (rewards) {
          this.autoRewardsPoints = rewards.autoRewardsPoints ?? 0;
          this.balance = rewards.balance ?? 0;
          this.dollarDiscount = rewards.dollarDiscount ?? 0;
          this.willExpire = rewards.willExpire ?? 0;
          this.isUserHasRewards = rewards.isUserHasRewards;

          if (this.isUserHasRewards && this.willExpire >= 0) {
              const expireText = this.willExpire == 1 ? 'expires ' : 'expire ';
              const dateAsOf = new Date();
              const displayDate = new Date(dateAsOf.getFullYear(), dateAsOf.getMonth() + 1, 0);
              this.rewardsPointsValueDetailsDisplay = this.willExpire === 1 ? `${this.willExpire.toLocaleString("en-US")} Point` : `${this.willExpire.toLocaleString("en-US")} Points`;
              this.rewardsPointsDateDetailsDisplay = expireText + `${displayDate.toLocaleString('default', { month: 'short' })} ${displayDate.getDate()}`;
          }
      }

      this.moreWaysToUseData.forEach(reward => {
          reward.rewardsAvailable = Math.floor(this.balance / 100);
          reward.pointsAvailable = this.balance;
          reward.rewardsExpire = this.willExpire;
      });
  }
  private focusOnRewardGrid() {
    if ($('reward-grid') && typeof $('reward-grid').ready !== 'undefined') {
      $('reward-grid').ready(() => {
        const focusItem = localStorage.getItem('rewardFocus');
        if (focusItem !== '') {
          $(`[data-focus="${focusItem}"]`).focus();
          localStorage.setItem('rewardFocus', '');
        }
      });
    }
  }

  private _showError() {
    this.showLoading = false;
    this.error = true;
    this.errorMessage = 'Sorry, we\'re having technical difficulties and working on fixing them, please check back later.';
  }

  private _isRegistered(): boolean {
    return (this.authService.isTokenValidForSession(this.userInfo));
  }

  openRewardsPage() {
    if (window['AB'] && window['AB']['DATALAYER']) {
      window['AB']['DATALAYER'].analyticsCTATracking('cta:rewards|linkclick|more-ways-to-use:view-rewards');
    }
    window.location.href ='/rewards/dashboard';
  }

  private analyticsEvents(message?:string) {
    if (window['AB'] && window['AB']['DATALAYER'] && localStorage.getItem('analyticsTabClicked')) {
      window['AB']['DATALAYER'].initAngularSPA('rewards', 'dashboard', 'morewaystouse', undefined, message);
      localStorage.removeItem('analyticsTabClicked');
    }
  }

}
